<template>
    <div class="bg">
        <div class="info">
            <div class="item">
                <label>姓 名</label>
                <input type="text"  readonly disabled v-model="info.name">
            </div>
            <div class="item">
                <label>手机号</label>
                <input type="text" readonly disabled v-model="info.phone">
            </div>
            <div class="item">
                <label>主持费(￥)</label>
                <input type="text" readonly disabled v-model="info.hostFee">
            </div>
            <div class="item">
                <label>讨论费(￥)</label>
                <input type="text" readonly disabled v-model="info.talkFee">
            </div>
            <div class="item">
                <label style="color: #2c9a58">户名*</label>
                <input type="text" placeholder="请填写户名" v-model="info.accountName">
            </div>
            <div class="item">
                <label style="color: #2c9a58">账号*</label>
                <input type="text" placeholder="银行账号" v-model="info.accountNo">
            </div>
            <div class="item">
                <label style="color: #2c9a58">开户行*</label>
                <input type="text" placeholder="请输入开户行" v-model="info.accountBank">
            </div>
            <div class="item">
                <label style="color: #2c9a58">身份证号*</label>
                <input type="text" placeholder="请输入身份证号码" v-model="info.id">
            </div>
            <div class="item-1">
                <div class="file-item">
                    <img id="img1" class="img" :src="info.idFront!=''?info.idFront:'https://ymd-lcc.oss-cn-beijing.aliyuncs.com/plus.png'" >
                    <input class="file" type="file" accept="image/*" multiple="multiple" @change="fileChange_1" ref="file_1">
                    <label class="hints">身份证正面</label>
                </div>
                <div class="file-item">
                    <img id="img2" class="img" :src="info.idBack!=''?info.idBack:'https://ymd-lcc.oss-cn-beijing.aliyuncs.com/plus.png'">
                    <input class="file" type="file" accept="image/*" multiple="multiple" @change="fileChange_2" ref="file_2">
                    <label class="hints">身份证反面</label>
                </div>
            </div>
            <div class="sign" v-if="info.sign!=null&&info.sign!=''">
                <label style="color: #2c9a58">签名</label>
                <img :src="info.sign">
            </div>
            <label class="hint">{{hint}}</label>
            <span @click="toSubmit()">提交</span>
        </div>
        <div class="sign-wrap" v-if="signShow">
            <Signature @setSign="setSign" @signClose="signClose" ></Signature>
        </div>
    </div>
</template>

<script>
    import {Indicator, MessageBox} from "mint-ui";
    import Signature from "@/components/sign/Signature";
    import {umedSignGet, umedSign} from "@/assets/js/api";
    import OSS from "ali-oss";
    import {getUuid} from "@/assets/util/util";

    export default {
        name: "SignInfo",
        components: {
            Signature
        },
        data(){
            return{
                infoId:this.$route.query.id,
                info:{
                    name:null,
                    phone:null,
                    talkFee:null,
                    hostFee:null,
                    accountName:null,
                    accountNo:null,
                    accountBank:null,
                    id:null,
                    sign:null,
                    idFront:null,
                    idBack:null
                },
                signShow:false,
                ossPrefix:"umed/sign/",
                hint:"**您提供的服务所得为税后所得，北京优迈迪科技有限公司将为您代扣代缴相关税费。为了保证相关税款缴纳的准确性和及时性，请您提供身份证复印件一份。上述身份证号码、及身份证复印件将被用于本次及以后（如发生）向您支付劳务所得及代扣代缴税费。北京优迈迪科技有限公司有限公司保证不将上述信息作为他用**"
            }
        },
        mounted(){
          this.getInfo(this.infoId)
        },
        methods:{
            fileChange_1(event){

                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });

                let fr = new FileReader();
                fr.readAsDataURL(event.target.files[0]);
                let _this = this
                fr.onload = function (e) {
                    document.getElementById('img1').src = e.target.result;

                    _this.ossUpload(_this.$refs.file_1.files[0]).then(function (res) {
                        console.log("1有")
                        _this.info.idFront = res
                        Indicator.close();

                    })

                };
            },
            fileChange_2(event){

                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });

                let fr = new FileReader();
                fr.readAsDataURL(event.target.files[0]);
                let _this = this
                fr.onload = function (e) {
                    document.getElementById('img2').src = e.target.result;

                    _this.ossUpload(_this.$refs.file_2.files[0]).then(function (res) {
                        console.log("2有")
                        _this.info.idBack = res
                        Indicator.close();
                    })

                };
            },
            async getInfo(infoId){
                const res = await  umedSignGet({infoId})
                if(res.data.success){
                    this.info = res.data.data
                }
                console.log(res,"124")
            },
            async sign(infoId,accountName,accountNo,accountBank,id,signBase64){

                let data ={
                    infoId:infoId,
                    accountName:accountName,
                    accountBank:accountBank,
                    accountNo:accountNo,
                    id:id,
                    signBase64: signBase64,
                    idFront:this.info.idFront,
                    idBack:this.info.idBack
                }

                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });
                const res = await umedSign({data})
                if(res.data.success){
                    Indicator.close()

                    let  message = "提交成功"
                    let _this =this
                    MessageBox({
                        title: '',
                        confirmButtonText:"确定",
                        message: message,
                        showCancelButton: false
                    }).then((res) => {
                        // this.$toast("开始提交")
                        if (res === 'confirm') {
                            _this.$router.go(0)
                        }
                    });


                    // this.$toast("提交成功")
                    // setTimeout(()=>{
                    //     this.$router.go(0)
                    // },1000)
                }else{
                    Indicator.close()
                    this.$toast(res.data.message)
                }

                console.log(res,"signInfo")
            },
            setSign(sign){
                this.signShow = false
                this.sign(this.infoId,this.info.accountName,this.info.accountNo,this.info.accountBank,this.info.id,sign)
            },
            signClose(){
                this.signShow = false
            },
            toSubmit(){
                // this.$toast("开始提交")
                if(this.info.accountName==null||this.info.accountName==''){
                    this.$toast("请填写户名")
                    return
                }
                if(this.info.accountNo==null||this.info.accountNo==''){
                    this.$toast("请填写银行账号")
                    return
                }
                if(this.info.accountBank==null||this.info.accountBank==''){
                    this.$toast("请填写开户行")
                    return
                }
                if(this.info.id==null||this.info.id==''){
                    this.$toast("请填写身份证号")
                    return
                }
                if(this.info.idFront==null||this.info.idFront==''){
                    this.$toast("请选择身份证正面")
                    return
                }
                if(this.info.idBack==null||this.info.idBack==''){
                    this.$toast("请选择身份证反面")
                    return
                }

                let  message = "提交前请确认基本信息和劳务费金额无误"
                let _this =this
                MessageBox({
                    title: '',
                    confirmButtonText:"开始签名",
                    message: message,
                    showCancelButton: true
                }).then((res) => {
                    // this.$toast("开始提交")
                    if (res === 'confirm') {
                        _this.signShow = true
                    }
                });

            },
            async ossUpload(file){

                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: 'gMpwhe9mmsnAxMPvVOc1TqWYkf1iyM',
                    bucket: 'ymd-lcc'
                })

                let uuid = getUuid()
                uuid+=("."+file.name.split(".")[1])
                let key = this.ossPrefix + uuid

                let link=""

                await client.put(key, file).then(function (res) {

                    let str = res.res.requestUrls[0]
                    let status = res.res.status
                    if(status == 200){
                        const workLink =  str.split("?")[0];
                        link = workLink
                    }else {
                        this.$toast("上传失败")
                    }
                }).catch((err) => {
                    console.log(err,"异常啦")
                    this.$toast("无法获取视频，请更换手机重试")
                })

                return link
            },

        }
    }
</script>

<style scoped lang="scss">
    .bg{
        width: 100%;
        height: 100vh;
        background: #fff url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        overflow: scroll;
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .bg .info{
        position: relative;
        margin-top: 10%;
        display: flex;
        flex-direction: column;
        .item{
            padding: 10px 0;
            font-size: 14px;
            width: 90%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            label{
                margin-right: 10px;
                width: 23%;
            }
            input{
                flex-grow: 1;
                margin: 0 auto;
                font-size: 14px;
                border: 1px #2c9a58 solid;
                border-radius: 5px;
                text-indent: 5px;
                outline: none;
                padding: 3px 0;
            }
        }
        .sign{
            padding: 10px 0;
            display: flex;
            flex-direction: row;
            font-size: 14px;
            label{
                margin-right: 10px;
                width: 23%;
            }
            img{
                width: 100px;
                height: 100px;
                display: flex;
                justify-content: flex-start;
            }
        }
        span{
            display: block;
            background: #2c9a58;
            color: #FFF;
            width: 60%;
            padding: 5px;
            margin: 30px auto 0;
            border-radius: 5px;
            font-size: 14px;
        }
        .hint{
            color: red;
            text-align: left;
            font-size: 10px;
            margin-left: 10%;
            margin-top: 10px;
        }
    }
    .sign-wrap{
        position: absolute;
        width: 90%;
        height: 10px;
        top: 20%;
        left: 0;
        right: 0;
        margin: auto;
        background: #FFF;
        border-radius: 20px;
        .close{
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
            position: relative;
            font-weight: normal;
            img{
                position: absolute;
                right: 20px;
                width: 25px;
                height: 25px;
            }
        }
    }

    .item-1{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-top: 20px;
    }

    .file-item{
        width: 30%;
        display: flex;
        flex-direction: column;
        position: relative;
        justify-content: space-around;
        img {
            width: 100%;
            height: 80px;
            margin: 0;
            padding: 0;
            object-fit: contain;
        }

        .file{
            width: 100%;
            height: 80px;
            position: absolute;
            left: 0;
            top: 0;
            opacity: 0;
        }

    }

    .hints{
        font-size: 12px;
        margin-top: 10px;
    }

</style>
